// extracted by mini-css-extract-plugin
module.exports = {"objectDelimiter":"Azure_objectDelimiter__2hyQz"};